import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type SessionEventType = 'EXPIRED' | 'ABORTED' | 'CLOSED';

@Injectable({ providedIn: 'root' })
export class SessionEventService {
  private readonly sessionEventSubject = new BehaviorSubject<SessionEventType | null>(null);
  // PAC whose /deposit-payment already succeeded - a later session event must not send /session/status for it
  private depositCreatedPacNumber: string | null = null;

  setSessionEvent(event: SessionEventType): void {
    console.log('session event set to: ', event)
    this.sessionEventSubject.next(event);
  }

  getSessionEvent(): Observable<SessionEventType | null> {
    console.log('session get event: ')
    return this.sessionEventSubject.asObservable();
  }

  clearSessionEvent(): void {
    this.sessionEventSubject.next(null);
  }

  markDepositCreated(pacNumber: string | undefined): void {
    this.depositCreatedPacNumber = pacNumber || null;
  }

  isDepositCreated(pacNumber: string | undefined): boolean {
    return !!pacNumber && this.depositCreatedPacNumber === pacNumber;
  }
}
